<template>
  <div>
    <g-title size="m" tag="h2">{{ storyTitle }}</g-title>
    <g-markdown class="intro" :content="storyIntro" />
    <div class="phone-divider" align="center">
      <img src="@/assets/svg/story-phone.svg" />
    </div>
    <RadioGroup
      v-for="(obj, index) in story.StoryCast"
      :key="'s' + index"
      :entity="'familiarSituation' + index"
      :label="'Har du upplevt något liknande som ' + obj.Name + '?'"
      :choices="[
        { Label: 'Ja', Value: '1' },
        { Label: 'Nej', Value: '0' }
      ]"
      @change="onDataChange"
    />

    <RadioGroup
      v-for="(obj, index) in story.StoryCast"
      :key="'t' + index"
      :entity="'familiarSituationFriend' + index"
      :label="
        'Har någon du känner upplevt något liknande som ' + obj.Name + '?'
      "
      :choices="[
        { Label: 'Ja', Value: '1' },
        { Label: 'Nej', Value: '0' }
      ]"
      @change="onDataChange"
    />

    <label>{{ storyText.FeedbackQuestionLabel }}</label>
    <textarea
      @input="event => onDataChange(event.target.value, 'message')"
    ></textarea>

    <g-button @click.prevent="nextStep">Spara & gå vidare</g-button>
  </div>
</template>

<script>
import Globals from '@/mixins/Globals';
import RadioGroup from '@/components/RadioGroup';
import GET_STORY from '@/graphql/story/GetStory.gql';

import GET_STORY_TEXTS from '@/graphql/story/GetStoryTexts.gql';
import UPDATE_STATISTIC from '@/graphql/story/UpdateStatistic.gql';

export default {
  components: {
    RadioGroup
  },
  mixins: [Globals],

  data() {
    return {
      formData: {},
      storyText: {
        FamiliarQuestionLabel: '',
        FeedbackQuestionLabel: ''
      },
      currentStoryId: false,
      story: false
    };
  },
  computed: {
    storyTitle() {
      return this.story ? this.story.Title : '';
    },
    storyIntro() {
      return this.story ? this.story.Intro : '';
    }
  },
  created() {
    let currentStory = JSON.parse(
      window.sessionStorage.getItem('currentStory')
    );

    if (currentStory) {
      this.currentStoryId = parseInt(currentStory.storyId);

      this.$apollo
        .query({
          query: GET_STORY,
          variables: {
            storyId: this.currentStoryId
          },
          notifyOnNetworkStatusChange: true
        })
        .then(({ data }) => {
          this.story = data.story;
        });
    }
  },
  apollo: {
    storyText: {
      query: GET_STORY_TEXTS
    }
  },
  methods: {
    async nextStep() {
      // Retrieves the current story object from session
      let currentStory = JSON.parse(
        window.sessionStorage.getItem('currentStory')
      );

      // Checks if the storyObject exisxts
      if (currentStory) {
        // Retrieve the user object
        let userObject = JSON.parse(
          window.sessionStorage.getItem('userObject')
        );

        // Checks if the user object has not 'stories' as property
        if (!userObject.hasOwnProperty('stories')) {
          userObject['stories'] = [currentStory]; // Makes new array with the current story object
        }

        // Get the story and the story index
        const userStories = userObject.stories;
        let existingStoryIndex = userStories.findIndex(
          story =>
            parseInt(story.storyId, 10) === parseInt(currentStory.storyId, 10)
        );

        // Checks if the current story is not present inside the user array
        if (existingStoryIndex === -1) {
          // Add the current story to the array and update the index
          existingStoryIndex = userObject.stories.push(currentStory);
        }

        // Set the reflection field with the present form-data
        userObject.stories[existingStoryIndex].reflection = this.formData;

        // Update the userObject inside the session storage
        window.sessionStorage.setItem('userObject', JSON.stringify(userObject));

        if (userObject.hasOwnProperty('statistic_id')) {
          const response = this.$apollo.mutate({
            mutation: UPDATE_STATISTIC,
            variables: {
              input: {
                where: {
                  id: parseInt(userObject.statistic_id)
                },
                data: {
                  Data: userObject
                }
              }
            }
          });
        }

        // Ta bort currentStory. Vi är klara med den
        window.sessionStorage.removeItem('currentStory');
      }

      // Slicea bort den story vi precis gjort ur story-loop
      const stories = JSON.parse(window.sessionStorage.getItem('story-loop'));
      const storyIndex = stories.findIndex(
        story => parseInt(story.id, 10) === parseInt(currentStory.storyId, 10)
      );

      if (storyIndex !== -1) {
        stories.splice(0, 1);
        window.sessionStorage.setItem('story-loop', JSON.stringify(stories));
      }

      // Checks if the user has stories left, if not the user will be redirected to the question-blocks

      const nextRoute = this.getNextRoute();
      this.$router.push(nextRoute);

      /* if (!this.hasStoriesLeft()) {
        this.$router.push({ name: 'question-blocks' });
        return;
      }

      // Go ba
      this.$router.push({ name: 'story-end' }); */
    },

    onDataChange(value, entity) {
      this.formData[entity] = value;
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  color: #202020;
  display: block;
  font-size: 18px;
  font-weight: 600;
  line-height: 23px;
  margin: 15px 0;
}

textarea {
  appearance: none;
  border: 0;
  font-family: 'Libre Franklin', Helvetica, Arial, sans-serif;
  font-size: 16px;
  height: 90px;
  margin-bottom: 15px;
  padding: 15px;
  resize: none;
  width: 100%;
}

.intro {
  font-size: 16px;
  font-weight: 400;
}
</style>
